export const isConnectedWhatsappBusinessAccount = (account) => (
    account?.is_connected === true
);

export const normalizeWhatsappBusinessAccounts = (payload) => {
    const accounts = Array.isArray(payload?.results) ? payload.results : payload;
    return Array.isArray(accounts) ? accounts : [];
};

export const getConnectedWhatsappBusinessAccounts = (payload) => (
    normalizeWhatsappBusinessAccounts(payload).filter(isConnectedWhatsappBusinessAccount)
);

export const getHistoricalWhatsappBusinessAccounts = (payload) => (
    normalizeWhatsappBusinessAccounts(payload).filter(
        (account) => !isConnectedWhatsappBusinessAccount(account)
    )
);

export const getFirstConnectedWhatsappBusinessAccount = (payload) => (
    getConnectedWhatsappBusinessAccounts(payload)[0] ?? null
);
